var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "process" }, [
    _c("div", { staticClass: "box" }, [
      _c("img", {
        attrs: { src: require("../../../static/image/submit@2x.png"), alt: "" }
      }),
      _vm._v(" "),
      _c("p", [_vm._v("提交订单")]),
      _vm._v(" "),
      _c("p", { staticClass: "mar-top-10" }, [_vm._v(_vm._s(_vm.createTime))])
    ]),
    _vm._v(" "),
    _vm._m(0),
    _vm._v(" "),
    _vm._m(1),
    _vm._v(" "),
    _vm._m(2),
    _vm._v(" "),
    _vm._m(3),
    _vm._v(" "),
    _vm._m(4),
    _vm._v(" "),
    _vm._m(5),
    _vm._v(" "),
    _vm._m(6),
    _vm._v(" "),
    _vm._m(7)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "spot" }, [
      _c("img", {
        attrs: { src: require("../../../static/image/line@2x.png"), alt: "" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "box" }, [
      _c("img", {
        attrs: { src: require("../../../static/image/payment@2x.png"), alt: "" }
      }),
      _vm._v(" "),
      _c("p", [_vm._v("付款成功")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "spot" }, [
      _c("p", { staticClass: "fs12 font-color-FF7 mar-bot-10" }, [
        _vm._v("等待发货")
      ]),
      _vm._v(" "),
      _c("img", {
        attrs: {
          src: require("../../../static/image/xzdiandian@2x.png"),
          alt: ""
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "box" }, [
      _c("img", {
        attrs: {
          src: require("../../../static/image/chuku_grey@2x.png"),
          alt: ""
        }
      }),
      _vm._v(" "),
      _c("p", [_vm._v("商品出库")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "spot" }, [
      _c("img", {
        attrs: {
          src: require("../../../static/image/huidiandian@2x.png"),
          alt: ""
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "box" }, [
      _c("img", {
        attrs: {
          src: require("../../../static/image/transport_grey@2x.png"),
          alt: ""
        }
      }),
      _vm._v(" "),
      _c("p", [_vm._v("等待收货")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "spot" }, [
      _c("img", {
        attrs: {
          src: require("../../../static/image/huidiandian@2x.png"),
          alt: ""
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "box" }, [
      _c("img", {
        attrs: {
          src: require("../../../static/image/complete_grey@2x.png"),
          alt: ""
        }
      }),
      _vm._v(" "),
      _c("p", [_vm._v("完成")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-62a1e8ad", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-62a1e8ad","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/status/statusTwo.vue
// module id = null
// module chunks = 